import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-review-requested-abstracts',
  templateUrl: './review-requested-abstracts.component.html',
  styleUrls: ['./review-requested-abstracts.component.css'],
  imports: []
})
export class ReviewRequestedAbstractsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
